import { render, staticRenderFns } from "./PvpHub.vue?vue&type=template&id=bc4c6318&scoped=true"
import script from "./PvpHub.vue?vue&type=script&lang=js"
export * from "./PvpHub.vue?vue&type=script&lang=js"
import style0 from "./PvpHub.vue?vue&type=style&index=0&id=bc4c6318&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4c6318",
  null
  
)

export default component.exports